import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const AccountBlockedToAllocation = ({ event }: { event: any }) => {
  const allocationName = event?.data?.allocationName ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      <strong>{event.data.allocationName}</strong> allocation
    </Box>
  ) : (
    'an allocation'
  );
  const accountId = event?.associatedEntities?.find((entity: any) => entity.type === 'sabalAccountId')?.id;
  const accountText = accountId ? (
    <Box as="span" display="inline-block" margin="0 2xs 0 0">
      account <strong>{accountId}</strong>
    </Box>
  ) : (
    'an account'
  );
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> blocked {accountText} from {allocationName}
      </Box>
    </Box>
  );
};

export default AccountBlockedToAllocation;
